import { naturalSort } from '@mode/shared/util-js';

/**
 * Order By Natural
 *
 * A filter that employs natural compare to sort arrays
 * @param arr - array of objects to sort
 * @param attr - item attribute to sort
 * @returns {*}
 */
export function OrderByNaturalFilter() {
  return (arr, attr) => {
    if (!Array.isArray(arr)) {
      return arr;
    }
    return arr.sort((a, b) => naturalSort(a[attr], b[attr]));
  };
}
